import { object, string, number, literal, z } from 'zod'
import { DEFAULT_MANDATORY_MESSAGE } from '~/constants'
import { validatePhone } from '~/helpers/validatePhone.helper'

export const countryValidationSchema = object({
  iso2: string().min(1, { message: DEFAULT_MANDATORY_MESSAGE }),
  name: string().min(1, { message: DEFAULT_MANDATORY_MESSAGE }),
  phone_code: string({ required_error: ' ' }).min(1, { message: ' ' }),
  id: number().min(1, { message: DEFAULT_MANDATORY_MESSAGE }),
})

export const phoneValidationSchema = object(
  {
    number: number({ required_error: DEFAULT_MANDATORY_MESSAGE }).min(1, {
      message: DEFAULT_MANDATORY_MESSAGE,
    }),
    country: countryValidationSchema,
  },
  { required_error: DEFAULT_MANDATORY_MESSAGE },
).superRefine(({ country: { iso2 }, number }, ctx) => {
  if (!validatePhone(number, iso2)) {
    ctx.addIssue({
      path: ['phone', 'phone.country.phone_code'],
      code: 'custom',
      message: 'Format is not valid',
    })
  }
})

export const nameValidationSchema = string({ required_error: DEFAULT_MANDATORY_MESSAGE }).min(4, {
  message: 'Must be at least 4 characters',
})

export const commissionSchema = string({ required_error: '' }).min(1, {
  message: '',
})

const emptyStringToUndefined = literal('').transform(() => undefined)

export function asOptionalField<T extends z.ZodTypeAny>(schema: T) {
  return schema.optional().or(emptyStringToUndefined)
}
